import React, { useState } from "react";
import styled from "styled-components";

const FAQAccordion = ({ data = {} }) => {
  const { eyebrow = "FAQ", title = "Answers To Your Most Common Questions", items = [] } = data;
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <FAQSection>
      <FAQContainer>
        <FAQHeader>
          <Eyebrow>{eyebrow}</Eyebrow>
          <Title>{title}</Title>
        </FAQHeader>

        <AccordionContainer>
          {items.map((item, index) => (
            <AccordionItem key={index} $isActive={activeIndex === index}>
              <AccordionHeader onClick={() => toggleAccordion(index)} $isActive={activeIndex === index}>
                <Question>{item.question}</Question>
                <AccordionIcon $isActive={activeIndex === index}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d={activeIndex === index ? "M18 15L12 9L6 15" : "M9 18L15 12L9 6"}
                      stroke="#1a1a1a"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </AccordionIcon>
              </AccordionHeader>

              <AccordionContent $isActive={activeIndex === index}>
                <Answer>{item.answer}</Answer>
              </AccordionContent>
            </AccordionItem>
          ))}
        </AccordionContainer>
      </FAQContainer>
    </FAQSection>
  );
};

export default FAQAccordion;

const FAQSection = styled.section`
  background: #ffffff;
  padding: 80px 20px;
  color: #1a1a1a;
  @media (max-width: 768px) { padding: 60px 20px; }
`;

const FAQContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const FAQHeader = styled.div`
  text-align: center;
  margin-bottom: 60px;
`;

const Eyebrow = styled.span`
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #1F514C;
  margin-bottom: 16px;
  padding: 6px 12px;
  border-radius: 4px;
`;

const Title = styled.h2`
  font-size: 42px;
  font-family: 'Playfair Display', serif;
  font-weight: 600;
  margin-bottom: 20px;
  color: #1a1a1a;
  line-height: 1.2;
  @media (max-width: 768px) { font-size: 32px; }
`;

const AccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const AccordionItem = styled.div`
  border: 1px solid ${props => props.$isActive ? '#1a1a1a' : '#e0e0e0'};
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  &:hover { border-color: ${props => props.$isActive ? '#1a1a1a' : '#b0b0b0'}; }
`;

const AccordionHeader = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 24px 30px;
  background: ${props => props.$isActive ? '#f8f9fa' : '#ffffff'};
  border: none;
  cursor: pointer;
  text-align: left;
  transition: all 0.3s ease;
  &:hover { background: #f8f9fa; }
  @media (max-width: 768px) { padding: 20px 24px; }
`;

const Question = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
  padding-right: 20px;
  line-height: 1.4;
  @media (max-width: 768px) { font-size: 16px; }
`;

const AccordionIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  min-height: 24px;
  transition: transform 0.3s ease;
  transform: rotate(${props => props.$isActive ? '180deg' : '0deg'});
`;

const AccordionContent = styled.div`
  max-height: ${props => props.$isActive ? '1000px' : '0'};
  opacity: ${props => props.$isActive ? '1' : '0'};
  overflow: hidden;
  transition: all 0.4s ease;
  border-top: 1px solid #f0f0f0;
`;

const Answer = styled.div`
  padding: 30px;
  font-size: 16px;
  line-height: 1.8;
  color: #444;
  white-space: pre-line;
  @media (max-width: 768px) { padding: 20px 24px; font-size: 15px; line-height: 1.6; }
`;
